/** Browser-storage keys. Everything the app keeps in local/session storage is named here. */
export const STORAGE_KEYS = {
  SESSION_TOKEN: 'club29.session-token',
  THEME: 'club29.theme',
  TEXT_SIZE: 'club29.text-size',
} as const;
